// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rrk7_","title":"styles_title__3wnB3"};